<tw-modal-header>Search</tw-modal-header>
<tw-modal-body>
  <tw-empty-state heading="Comming soon"></tw-empty-state>


<!--  <tw-search-input
    [(value)]="query"
    placeholder="Search pages…"
    aria-label="Search pages" />

  &lt;!&ndash; Results — flat, security-filtered list of palette-surface pages.
       Renders an empty-state message when nothing matches. &ndash;&gt;
  @if (results().length > 0) {
    <ul class="tw-command-palette__results" role="listbox" aria-label="Search results">
      @for (result of results(); track result.id) {
        <li class="tw-command-palette__result" role="option">
          <button
            type="button"
            class="tw-command-palette__result-button"
            (click)="onSelect(result)">
            <span class="tw-command-palette__result-label">{{ result.label }}</span>
            @if (result.group) {
              <span class="tw-command-palette__result-group">{{ result.group }}</span>
            }
          </button>
        </li>
      }
    </ul>
  } @else {
    <p class="tw-command-palette__empty">No matching pages.</p>
  }-->
</tw-modal-body>
